import { render, staticRenderFns } from "./VoucherReceipt.vue?vue&type=template&id=200788b4&"
import script from "./VoucherReceipt.vue?vue&type=script&lang=js&"
export * from "./VoucherReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports